<template>
  <div>
    <v-dialog
      :value="shareDialog"
      @input="$emit('setShareDialog', false)"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <v-btn
            color="success"
            class="text-none mb-4"
            @click="exectPublish()"
            :loading="publishLoading"
          >
            <v-icon>mdi-earth</v-icon>
            Publish
          </v-btn>
        </v-card-title>
        <v-card-subtitle v-if="type === 'brain'" class="gray--text">
          By clicking this button, this brain data will be added to the public
          brain repository and anyone will be able to view the data.
        </v-card-subtitle>
        <v-card-subtitle v-if="type === 'notebook'" class="gray--text">
          By clicking this button, this notebook will be added to the public
          notebook repository and anyone will be able to view the data.
        </v-card-subtitle>
        <v-card-subtitle v-if="type === 'studio'" class="gray--text">
          Note: All brains in the studio will be automatically made public.
        </v-card-subtitle>
        <v-card-title>Shared users</v-card-title>
        <v-card-subtitle v-if="type === 'notebook'" class="red--text">
          Note: All brains in the 'Groups' will be automatically shared with the
          users you designated.
        </v-card-subtitle>
        <v-card-subtitle v-if="type === 'studio'" class="red--text">
          Note: All brains in the studio will be automatically shared with the
          users you designated.
        </v-card-subtitle>
        <v-card-text>
          <v-row dense v-for="(user, index) in currentUsers" :key="user.Email">
            <v-col cols="1"><v-icon large>mdi-account-box</v-icon></v-col>
            <v-col cols="5" class="mt-1">
              <div class="text--primary subtitle-1">
                {{ user.Email }}
              </div>
            </v-col>
            <v-col cols="3" class="mt-1">
              <div v-if="!user.editable" class="text--primary subtitle-1">
                {{ user.Permission === 'r' ? 'Read only' : 'Read and write' }}
              </div>
              <v-select
                v-if="user.editable"
                :items="permissionItems"
                dense
                hide-details
                v-model="user.Permission"
              />
            </v-col>
            <template v-if="user.loading">
              <v-progress-circular class="ml-3" indeterminate color="primary" />
            </template>
            <template v-else-if="user.editable">
              <v-col cols="1">
                <v-btn
                  icon
                  color="success"
                  class="mr-2 ml-3"
                  @click="execChangePermission(user, index)"
                >
                  <v-icon>mdi-check</v-icon>
                </v-btn>
                <v-btn
                  text
                  color="error"
                  class="text-none"
                  @click="
                    user.editable = false
                    currentUsers.splice(index, 1, user)
                  "
                >
                  cancel
                </v-btn>
              </v-col>
            </template>
            <template v-else>
              <v-col cols="1">
                <v-btn
                  text
                  color="success"
                  class="text-none"
                  @click="
                    user.editable = true
                    currentUsers.splice(index, 1, user)
                  "
                >
                  <span>Edit</span>
                </v-btn>
              </v-col>
              <v-col cols="1">
                <v-btn
                  text
                  color="error"
                  class="text-none"
                  @click="execDelete(user, index)"
                >
                  <span>Remove</span>
                </v-btn>
              </v-col>
            </template>
          </v-row>
          <v-row dense v-for="(newUser, index) in newUsers" :key="newUser.id">
            <v-col cols="1"><v-icon large>mdi-account-box</v-icon></v-col>
            <v-col cols="6">
              <v-form v-model="newUser.valid" @submit.prevent>
                <v-text-field
                  v-model="newUser.Email"
                  placeholder="Email address"
                  :rules="newMailRules"
                  :error-messages="newUser.errorMessage"
                  outlined
                  dense
                  :name="'user_' + index"
                />
              </v-form>
            </v-col>
            <v-col cols="3">
              <v-select
                :items="permissionItems"
                dense
                hide-details
                v-model="newUser.Permission"
                class="ml-3"
              />
            </v-col>
            <v-col v-if="newUser.loading" cols="2">
              <v-progress-circular class="ml-3" indeterminate color="primary" />
            </v-col>
            <v-col v-else cols="2">
              <v-btn
                icon
                color="success"
                :disabled="!newUser.Email || !newUser.valid"
                class="mr-2 ml-3"
                @click="execShare(newUser, index)"
              >
                <v-icon>mdi-check</v-icon>
              </v-btn>
              <v-btn
                text
                color="error"
                class="text-none"
                @click="newUsers.splice(index, 1)"
              >
                cancel
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col class="ml-3">
              <v-btn color="success" class="text-none" @click="addNewUser">
                <span>Add</span>
              </v-btn>
            </v-col>
            <v-col class="text-right mr-4">
              <v-btn
                color="error"
                class="text-none"
                @click="$emit('setShareDialog', false)"
              >
                <span>Close</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm-dialog ref="confirm" />
  </div>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
  },
  data: (self) => ({
    currentUsers: [],
    newUsers: [],
    permissionItems: [
      {
        text: 'Read only',
        value: 'r',
      },
      {
        text: 'Read and write',
        value: 'rw',
      },
    ],
    newMailRules: [(v) => /.+@.+\..+/.test(v) || 'Invalid format.'],
    isRestore: false,
    publishLoading: false,
  }),
  props: {
    type: {
      type: String,
      validator(val) {
        return ['brain', 'notebook', 'studio'].includes(val)
      },
      required: true,
    },
    shareDialog: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      required: true,
    },
  },
  computed: {
    canSubmit: function() {
      return (
        (this.currentUsers.length > 0 && this.newUsers.length === 0) ||
        (this.newUsers.length > 0 && this.valid)
      )
    },
  },
  methods: {
    addNewUser() {
      this.newUsers.push({
        id: this.$uuid.v4(), // This is only used for v-bind:key.
        Email: null,
        Permission: 'r',
        valid: false,
      })
    },
    async init() {
      const result = await this.getShared(this.id, this.type)
      if (!result) {
        return
      }
      this.currentUsers = result.data
      for (const user of this.currentUsers) {
        user.oldPermission = user.Permission
        user.editable = false
      }
    },
    async execDelete(user, index) {
      this.currentUsers.splice(index, 1)
      await this.deleteShared(this.id, user.Email, this.type)
      this.$emit('initParent')
    },
    async execChangePermission(user, index) {
      if (user.oldPermission === user.Permission) {
        user.editable = false
        this.currentUsers.splice(index, 1, user)
        return
      }
      user.loading = true
      this.currentUsers.splice(index, 1, user)
      const param = this.$_createParamFrom(user)
      const deleteResult = await this.deleteShared(
        this.id,
        param.Email,
        this.type
      )
      if (!deleteResult) {
        user.editable = false
        this.currentUsers.splice(index, 1, user)
        return
      }
      try {
        await this.postShare(this.id, param, this.type)
      } catch (error) {
        // Usually, no error occurs at this timing, this is just in case.
        alert(this.getCommonErrorMessage(error))
        this.currentUsers.splice(index, 1)
        return
      }
      user.oldPermission = user.Permission
      user.editable = false
      user.loading = false
      this.currentUsers.splice(index, 1, user)
    },
    async exectPublish() {
      if (
        await this.$refs.confirm.open(
          'Are you sure you want to publish this data? This oepration cannot be undone.',
          'Yes'
        )
      ) {
        try {
          this.publishLoading = true
          await this.postPublishV2(this.id, this.type)
          this.publishLoading = false
        } catch (error) {
          alert(this.getCommonErrorMessage(error))
        }
      }
    },
    async execShare(user, index) {
      user.loading = true
      this.newUsers.splice(index, 1, user)
      const param = this.$_createParamFrom(user)
      try {
        await this.postShare(this.id, param, this.type)
      } catch (error) {
        if (error.response && error.response.data.InvalidEmail) {
          alert(
            'The email address that you typed was not found in our user database.'
          )
        } else if (error.response && error.response.data.Message) {
          alert(error.response.data.Message)
        } else {
          alert(this.getCommonErrorMessage(error))
        }
        user.loading = false
        this.newUsers.splice(index, 1, user)
        return
      }
      user.loading = false
      this.currentUsers.push(user)
      this.newUsers.splice(index, 1)
      this.$emit('initParent')
    },
    $_createParamFrom(user) {
      return {
        Email: user.Email,
        Permission: user.Permission,
      }
    },
  },
  mounted() {
    this.init()
  },
}
</script>
